<template>
  <div class="topbar">
    <div class="topbar-bg">
      <el-popover placement="bottom" width="150" trigger="hover">
        <span
          class="u-m-r-10 text-bold pointer"
          slot="reference"
          v-text="$t('locale')"
        ></span>
        <div
          @click="triggerLanguage(item.value)"
          class="languages"
          v-for="(item, index) in localeValue"
          :key="index"
        >
          <span
            :class="{ 'languages-actvie': $i18n.locale == item.value }"
            v-text="item.label"
          ></span>
        </div>
      </el-popover>
      <template v-if="hasLogin">
        <span v-t="'hi'"></span>
        <a
          class="u-m-l-10"
          style="color: var(--r_theme)"
          @click.stop.prevent="$router.push('/user/account')"
          >{{ nickname }}</a
        >

        <span class="u-p-l-4 u-p-r-4">|</span>
        <a @click.stop.prevent="logout">{{ $t("exit") }}</a>
      </template>
      <template v-else>
        <a class="u-m-l-10" @click.stop.prevent="$router.push('/login')">{{
          $t("loginOperations[0]")
        }}</a>
        <span class="u-p-l-4 u-p-r-4">|</span>
        <a class @click.stop.prevent="$router.push('/register')">{{
          $t("loginOperations[1]")
        }}</a>
        <span class="u-p-l-4 u-p-r-4">|</span>
        <a class @click.stop.prevent="$router.push('/forget')">{{
          $t("loginOperations[2]")
        }}</a>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Cookies from 'js-cookie'
import { setLocale } from '@/plugins/i18n'   // 加上这一行

export default {
  computed: {
    ...mapGetters(['nickname', 'hasLogin']),
  },
  data() {
    return {
      localeValue: [
        { label: '繁體中文', value: 'zh-TW' },
        { label: '简体中文', value: 'zh-CN' },
        { label: 'English', value: 'en' },
      ],
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('user/LogOut').then(() => {
        // this.$router.push('/')//不用跳，路由守卫自动处理
      })
    },
    triggerLanguage(value) {
      if (this.$i18n.locale != value) {
        setLocale(value)   // 改成调用这个
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.topbar {
  color: #fff;
  background: var(--theme);
  display: flex;
  justify-content: flex-end;
  height: 30px;
  line-height: 30px;

  a {
    cursor: pointer;

    &:hover {
      text-decoration: none;
      color: var(--r_theme);
    }
  }

  &-bg {
    background: url("@/assets/img/tool_bar_bg.png");
    padding: 0 10px 0 30px;
  }
}

.languages {
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  padding: 5px 0;
  letter-spacing: 3px;
  word-spacing: 3px;

  &:hover,
  &-actvie {
    color: var(--theme);
  }
}
</style>